export default {
	title: 'My trail',
	subtitle: "What you've marked and noted.",
	search: {
		placeholder: 'Search your trail',
	},
	filters: {
		all: 'All',
		favorites: 'Favorites',
		notes: 'Notes',
		content: 'Content',
		resources: 'Resources',
		allPrograms: 'All {{collectionEntityLabelPluralLower}}',
	},
	count: '{{visible}} of {{total}} items',
	page: 'page {{page}} of {{total}}',
	empty: {
		none: {
			title: "You haven't left a trail yet",
			description:
				'Mark content as a criterion, favorite a resource or take a note: it will show up here so you can find it again.',
		},
		filtered: {
			title: 'No matching items',
			description:
				'Try another filter or come back once you have marked content.',
		},
	},
	pagination: {
		previous: 'Previous',
		next: 'Next',
	},
	detail: {
		placeholder: {
			title: 'Select a mark from your trail',
			description:
				'The reading will open here with the full context of the resource, content or note.',
		},
		backToIndex: 'Back to index',
		openInContext: 'Open in its original context',
		notesTitle: 'Personal notes',
	},
	item: {
		note: 'Note',
	},
	labels: {
		state: {
			favorite: 'Favorite',
			note: 'Personal note',
		},
		target: {
			content: 'Content',
			resource: 'Resource',
		},
		resourceTypes: {
			video: 'Video',
			book: 'Book',
			pdf: 'PDF',
			post: 'Post',
			image: 'Image',
			link: 'Link',
			file: 'File',
			model3d: '3D model',
		},
	},
}
